// extracted by mini-css-extract-plugin
export default {"container":"cPDxH","content":"iwsnL"};